/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Event_Tourism_Hospitality23Inputs */

const en_job_form_enum_event_tourism_hospitality23 = /** @type {(inputs: Job_Form_Enum_Event_Tourism_Hospitality23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event, Tourism and Hospitality`)
};

const de_job_form_enum_event_tourism_hospitality23 = /** @type {(inputs: Job_Form_Enum_Event_Tourism_Hospitality23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung, Tourismus und Gastgewerbe`)
};

/**
* | output |
* | --- |
* | "Event, Tourism and Hospitality" |
*
* @param {Job_Form_Enum_Event_Tourism_Hospitality23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_event_tourism_hospitality23 = /** @type {((inputs?: Job_Form_Enum_Event_Tourism_Hospitality23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Event_Tourism_Hospitality23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_event_tourism_hospitality23(inputs)
	return en_job_form_enum_event_tourism_hospitality23(inputs)
});
export { job_form_enum_event_tourism_hospitality23 as "job_form_enum_EVENT_TOURISM_HOSPITALITY" }